import { Construtor } from './construtor';

export class FiltroResultadoColeta implements Construtor<FiltroResultadoColeta> {

  public idCliente: number;
  public idUsuario: number[];
  public dataInicioReferencia: Date;
  public dataFimReferencia: Date;
  public idPontoFisico: number[];
  public idSetorPontoFisico: number[];
  public idProcessoSetor: number[];
  public idRotinaProcesso: number[];
  public idCriterioAvaliacao: number[];

  constructor(object?: any) {

    this.idUsuario = new Array<number>();
    this.idPontoFisico = new Array<number>();
    this.idSetorPontoFisico = new Array<number>();
    this.idProcessoSetor = new Array<number>();
    this.idRotinaProcesso = new Array<number>();
    this.idCriterioAvaliacao = new Array<number>();

    if (object !== undefined) {

      if (object instanceof FiltroResultadoColeta) {
        this.copyObject(object);
      } else {
        this.parseFromJson(object);
      }

      if (!this.modeloCompleto()) {
        return null;
      }
    }

    return this;
  }

  copyObject(coleta: FiltroResultadoColeta): void {
    this.idCliente = coleta.idCliente;
    this.idUsuario = coleta.idUsuario;
    this.dataInicioReferencia = coleta.dataInicioReferencia;
    this.dataFimReferencia = coleta.dataFimReferencia;
    this.idPontoFisico = coleta.idPontoFisico;
    this.idSetorPontoFisico = coleta.idSetorPontoFisico;
    this.idProcessoSetor = coleta.idProcessoSetor;
    this.idRotinaProcesso = coleta.idRotinaProcesso;
    this.idCriterioAvaliacao = coleta.idCriterioAvaliacao;
  }

  parseFromJson(coleta: any): void {
    this.idCliente = coleta.idCliente;
    this.idUsuario = coleta.idUsuario;
    this.dataInicioReferencia = coleta.dataInicioReferencia;
    this.dataFimReferencia = coleta.dataFimReferencia;
    this.idPontoFisico = coleta.idPontoFisico;
    this.idSetorPontoFisico = coleta.idSetorPontoFisico;
    this.idProcessoSetor = coleta.idProcessoSetor;
    this.idRotinaProcesso = coleta.idRotinaProcesso;
    this.idCriterioAvaliacao = coleta.idCriterioAvaliacao;
  }

  modeloCompleto(): boolean {
    return this.idCliente !== undefined &&
      this.idUsuario !== undefined;
  }

  getNewInstance(object?: any): FiltroResultadoColeta {
    return new FiltroResultadoColeta(object);
  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/modelos/filtro-resultado-coleta.ts